import {DetailsBox, IconBox, SpaceBetweenBox, StatusBox, StyledAssessmentIcon, StyledDateRangeIcon, StyledDnsIcon, StyledPermIdentityIcon, TitleBox, VersionChip} from '../../AutoProjectTrainingStatusTab/Style/AutoProjectTrainingStatusTab.style';
import {Body1, Subtitle1} from '../../../ui-library';
import React from 'react';
import useAutoProject from '../../../pages/AutoProject/Controller/AutoProject.controller';
import {Timer} from '../../Timer';
import {FeatureVersionStatus} from '../../../pages/AutoProject/Config/AutoProject.constants';


const AutoTrainingStatusDataView = ({feature, version}) => {
    const {formatDate} = useAutoProject();

    return (
        <>
            <SpaceBetweenBox>
                <TitleBox>
                    <Subtitle1>{feature}</Subtitle1>{version.version_number && <VersionChip label={`v${version.version_number}`} variant='outlined'/>}
                </TitleBox>
                {version.status && <StatusBox>
                    <Body1>{version.status}</Body1>
                    {version.status === FeatureVersionStatus.InProgress && <Timer
                        startDate={Date.parse(version.train_start_time)}/>}
                </StatusBox>}
            </SpaceBetweenBox>
            <DetailsBox>
                {version.user && <IconBox>
                    <StyledPermIdentityIcon/>
                    <Body1> {version.user} </Body1>
                </IconBox>}
                {version.training_images_counter && <IconBox>
                    <StyledDnsIcon/>
                    <Body1> {version.training_images_counter} </Body1>
                </IconBox>}
                {version.evaluation_images_counter && <IconBox>
                    <StyledAssessmentIcon/>
                    <Body1> {version.evaluation_images_counter} </Body1>
                </IconBox>}
                {version.train_start_time && <IconBox>
                    <StyledDateRangeIcon/>
                    <Body1> {formatDate(version.train_start_time)} </Body1>
                </IconBox>}
                {version.id && <IconBox>
                    <Body1>ID: </Body1>
                    <Body1>{version.id}</Body1>
                </IconBox>}
            </DetailsBox>
        </>
    );
};


export default AutoTrainingStatusDataView;
